export const baseURL = 'https://coins-api.onrender.com/';
export const coinMarketAPIKey = 'a4552acd-1935-43d8-8a8d-9dca4601ca12';